export default {
  SolidStraightStroked: 'SolidStraightStroked',
  SolidCurveStroked: 'SolidCurveStroked',
};
